export function readPath(row: unknown, path: string): unknown {
    return path.split('.').reduce<unknown>((acc, key) => {
        if (acc === null || acc === undefined) return undefined;
        return (acc as Record<string, unknown>)[key];
    }, row);
}
